import { render, staticRenderFns } from "./HandlerFlowTask.vue?vue&type=template&id=4a0873d7&scoped=true&"
import script from "./HandlerFlowTask.vue?vue&type=script&lang=js&"
export * from "./HandlerFlowTask.vue?vue&type=script&lang=js&"
import style0 from "./HandlerFlowTask.vue?vue&type=style&index=0&id=4a0873d7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a0873d7",
  null
  
)

export default component.exports